import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_automation_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AUTOMATIONS_KEY } from '@/utils/queryKeys.ts';

type DeleteAutomationParams = {
  id: string;
};

const useDeleteAutomation = (): UseMutationResult<void, AxiosError, DeleteAutomationParams> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeleteAutomationParams) => {
      await apiClient.delete(get_automation_url(id));
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: AUTOMATIONS_KEY });
    },
  });
};

export default useDeleteAutomation;
